'use client';

import { useSyncExternalStore } from 'react';

export const SERVER_TIME_ZONE = 'America/New_York';

const subscribe = () => () => {};
const getServerTimeZone = () => SERVER_TIME_ZONE;

function getViewerTimeZone() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return timeZone && timeZone !== 'Etc/Unknown' ? timeZone : SERVER_TIME_ZONE;
}

/**
 * Uses Eastern Time for SSR and the first hydration render, then switches to the
 * viewer's time zone without withholding the surrounding content from the server.
 */
export function useViewerTimeZone(): string {
    return useSyncExternalStore(subscribe, getViewerTimeZone, getServerTimeZone);
}
